import React from "react";
import {canHaveAllResist, canHaveArmor, canHaveDps, CLASSES} from "../../commons/enums/D4Enums";
import {findIndexIgnoreCase} from "../../commons/Utils/ArrayUtils";
import EiaTextField from "../EiaTextField";
import {testInteger, testShortFloat} from "../../commons/Utils/RegExUtils";
import EiaSelect from "../EiaSelect";
import {MAX_HERO_LEVEL} from "../../commons/enums/D4Constants";

const D4ItemBaseStatSelect = function(props) {
    const {baseItem, baseStats, setBaseStats, searchDefaults} = props;

    const defaultLevelRequirement = searchDefaults ? MAX_HERO_LEVEL : 0;
    const itemPowerLabel = searchDefaults ? "Item Power (min)" : "Item Power";
    const levelRequirementLabel = searchDefaults ? "Level Requirement (max)" : "Level Requirement";
    const armorLabel = searchDefaults ? "Armor (min)" : "Armor";
    const allResistLabel = searchDefaults ? "All Resist (min)" : "All Resist";
    const dpsLabel = searchDefaults ? "Damage per Second (min)" : "Damage per Second";

    const isBaseStats = Object.keys(baseStats).length > 0;

    const armor = isBaseStats ? baseStats.armor : 0;
    const allResist= isBaseStats ? baseStats.allResist : 0;
    const dps = isBaseStats ? baseStats.dps : 0;
    const itemPower = isBaseStats ? baseStats.itemPower : 0;
    const levelRequirement = isBaseStats ? baseStats.levelRequirement : defaultLevelRequirement;
    const classRequirement = isBaseStats ? baseStats.classRequirement : "Any";
    const classRequirementIndex = findIndexIgnoreCase(CLASSES, classRequirement);

    const getTempBaseStats=function() {
        const temp = Object.assign([], baseStats);
        temp.armor = armor;
        temp.allResist = allResist;
        temp.dps = dps;
        temp.levelRequirement = levelRequirement;
        temp.classRequirement = classRequirement;
        temp.itemPower = itemPower;
        return temp;
    }

    function setBaseStat(key, value) {
        const temp = getTempBaseStats();
        temp[key] = value;
        setBaseStats(temp);
    }

    function setClassIndex(index) {
        const temp = getTempBaseStats();
        temp.classRequirement = CLASSES[index];
        setBaseStats(temp);
    }

    return (
            <div>
                    <EiaTextField validator={testInteger} onChange={(e) => setBaseStat("itemPower", e.currentTarget.value)} label={itemPowerLabel} value={itemPower}/>
                    <EiaSelect title={"Class Requirement"} values={CLASSES} value={classRequirementIndex} onChange={(e) => setClassIndex(e.target.value)}/>
                    <EiaTextField validator={testInteger} onChange={(e) => setBaseStat("levelRequirement", e.currentTarget.value)} label={levelRequirementLabel} value={levelRequirement}/>
                    {
                        canHaveDps(baseItem, baseStats) ? <EiaTextField validator={testShortFloat} onChange={(e) => setBaseStat("dps", e.currentTarget.value)} label={dpsLabel} value={dps}/> : null
                    }
                    {
                        canHaveArmor(baseItem, baseStats) ? <EiaTextField validator={testShortFloat} onChange={(e) => setBaseStat("armor", e.currentTarget.value)} label={armorLabel} value={armor}/> : null
                    }
                {
                    canHaveAllResist(baseItem, baseStats) ? <EiaTextField validator={testShortFloat} onChange={(e) => setBaseStat("allResist", e.currentTarget.value)} label={allResistLabel} value={allResist}/> : null
                }
            </div>
    )
}
export default D4ItemBaseStatSelect;